module.exports = __webpack_public_path__ + "static/img/got_1_box.e5412aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/answer_pop_up/got_1_box.png
// module id = Qx0f
// module chunks = 1